module.exports = __webpack_public_path__ + "static/media/Cylinder1.f3b7138c.jpg";